import React from 'react';

const LoadingSpinner = ({ fullScreen = false, size = 'md', label = '' }) => {
  const sizes = { sm: 'w-5 h-5', md: 'w-8 h-8', lg: 'w-12 h-12', xl: 'w-16 h-16' };

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3" role="status">
      <div aria-hidden="true" className={`${sizes[size]} border-2 border-dark-400 border-t-brand-500 rounded-full animate-spin`} />
      {label
        ? <p className="text-secondary text-sm">{label}</p>
        : <span className="sr-only">Loading…</span>}
    </div>
  );

  if (fullScreen) {
    // Full screen means it stands in for the whole page (a route guard checking the
    // session, a screen downloading, a page fetching its data), so it is the page's
    // main landmark, as every page has one (Codex review, PR 431). The "status" role,
    // which announces it to screen readers, moves onto the inner block: a role on the
    // <main> itself would replace its landmark role.
    return (
      <main className="fixed inset-0 bg-dark-900 flex items-center justify-center z-50">
        <div className="flex flex-col items-center gap-4" role="status">
          <div aria-hidden="true" className="w-16 h-16 border-2 border-dark-400 border-t-brand-500 rounded-full animate-spin" />
          <div className="text-center">
            <h2 className="text-xl font-serif text-brand-ink tracking-wide">Mixtape Memories</h2>
            <p className="text-secondary text-sm mt-1">{label || 'Loading…'}</p>
          </div>
        </div>
      </main>
    );
  }

  return spinner;
};

export default LoadingSpinner;
